import React from 'react';
import { Box, ButtonBase, Popover, Typography } from '@mui/material';
import moment from 'moment';
import { MedicationEvent } from '../types';
import { getStatusIcon } from '../utils/statusUtils';
import { dimGrey, lightBlack } from '../../../../../../mainTheme';

interface SlotOverflowPopoverProps {
  events: MedicationEvent[];
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  onSelectEvent: (event: MedicationEvent) => void;
}

/** Lists the med events that did not fit side-by-side in a 15-minute slot. */
const SlotOverflowPopover: React.FC<SlotOverflowPopoverProps> = ({
  events,
  anchorEl,
  open,
  onClose,
  onSelectEvent,
}) => {
  if (!events.length) return null;

  const slotLabel = moment(events[0].start).format('h:mm A');

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      slotProps={{
        paper: {
          sx: {
            minWidth: 240,
            borderRadius: '12px',
            boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.10)',
          },
        },
      }}
    >
      <Box sx={{ py: 1 }}>
        <Typography
          sx={{
            px: 2,
            py: 0.5,
            fontWeight: 700,
            fontSize: '14px',
            lineHeight: '20px',
            letterSpacing: '0.2px',
            color: lightBlack,
          }}
        >
          {`${events.length} more at ${slotLabel}`}
        </Typography>
        {events.map((event) => (
          <ButtonBase
            key={event.id}
            onClick={() => onSelectEvent(event)}
            sx={{
              display: 'flex',
              width: '100%',
              gap: '8px',
              px: 2,
              py: 1,
              justifyContent: 'flex-start',
              textAlign: 'left',
              '&:hover': { backgroundColor: '#F6F6F9' },
            }}
          >
            {getStatusIcon(event.status)}
            <Typography
              sx={{
                flexGrow: 1,
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '20px',
                letterSpacing: '0.2px',
                color: lightBlack,
              }}
            >
              {event.title}
            </Typography>
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '20px',
                letterSpacing: '0.2px',
                color: dimGrey,
              }}
            >
              {moment(event.start).format('h:mm A')}
            </Typography>
          </ButtonBase>
        ))}
      </Box>
    </Popover>
  );
};

export default SlotOverflowPopover;
